module.exports = __webpack_public_path__ + "static/bathroom-clearance-min-26c9ac450b3f325882c0c86088324d4e.png";